export default store => next => action => {
    switch (action.type) {
    case "RESET_STAGE_CASE": {
        const state = store.getState();
        const stages = state.stages.get("data");
        // const stagePermissions = state.stagePermissions.get("data");
        // const user = state.user.get("data");
        // const isPermittedStage = stagePermissions.find(
        //     _ => _.id === action.payload.stage
        // );
        next({
            type: action.type,
            payload: {
                ...action.payload,
                stageName: stages.find(_ => _.id === action.payload.stage)
                    .stage_name
                    // type: isPermittedSta"BOTH"
            }
        });
        break;
    }

    default:
        next(action);
    }
};
